import { ButtonLink } from 'components/UI'
import { ButtonGroup } from 'ui'
import { hasAccessToThis, isMobile } from 'services/Utilities'

const TopBarModule: React.FC = () => {
  const isAManager = hasAccessToThis('managerPanel')
  const isAnAdmin = hasAccessToThis('adminPanel')
  const buttonSize = isMobile() ? 'btn' : 'btn-sm'
  const { pathname } = location

  return (
    <ButtonGroup>
      {isAnAdmin || isAManager ? (
        <ButtonLink className={buttonSize} href="/my/home" text="components.topBar.EMPLOYEE" light active={pathname.includes('/my')} />
      ) : null}
      {isAManager ? (
        <ButtonLink
          className={buttonSize}
          href="/manage/dashboard"
          text="components.topBar.MANAGER"
          active={pathname.includes('/manage')}
          icon="business-time"
          light
        />
      ) : null}
      {isAnAdmin ? (
        <ButtonLink className={buttonSize} href="/admin" text="components.topBar.ADMINISTRATION" active={pathname.includes('/admin')} icon="tools" light />
      ) : null}
    </ButtonGroup>
  )
}

export default TopBarModule
